import { useEffect, useState } from 'react'
import type { RequestStatus } from '@sales-center/common'
import { useActivitiesContext } from '../context'
import { fetchAllActivityTypes } from '../ActivitiyTypes/effects'

export function useFetchActivityTypes() {
  const [state, setState] = useState<RequestStatus>('idle')
  const [, dispatch] = useActivitiesContext()

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      setState('loading')

      const action = await fetchAllActivityTypes()

      if (mounted) {
        dispatch(action)
        setState('idle')
      }
    }

    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return state
}
